// extracted by mini-css-extract-plugin
export default {"galleryInfoCard":"GalleryInfoCard_galleryInfoCard__HBRE9","title":"GalleryInfoCard_title__tVvUW"};